import { DevicesNotificationFileTypes, IDropboxPushMessage, DevicesNotificationTypes } from 'types';

export const dropboxPushFileTypes: DevicesNotificationFileTypes[] = [
	DevicesNotificationFileTypes.TOMBSTONES,
	DevicesNotificationFileTypes.PS_LOGS,
	DevicesNotificationFileTypes.PS_DATABASE,
];

export const dropboxPushMessages: IDropboxPushMessage[] = [
	{ value: DevicesNotificationTypes.PushDropBoxUploadFilePull, name: 'UPLOAD_FILE_PULL' },
	{ value: DevicesNotificationTypes.PushDropBoxUploadLauncherFilePull, name: 'UPLOAD_LAUNCHER_FILE_PULL' },
];
